var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "17px",
    viewBox: "0 0 20 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "twitter-logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "twitter-logo",
    fill: "#6C757D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,1.93653595 C19.2638889,2.26271242 18.4740523,2.48392157 17.644183,2.58267974 C18.4915359,2.07526144 19.1401634,1.27042484 19.4475817,0.314346405 C18.6527451,0.784248366 17.7753922,1.12545752 16.8405556,1.31042484 C16.0919608,0.511830065 15.0271569,0.0144117647 13.8461111,0.0144117647 C11.5802941,0.0144117647 9.74313725,1.85156863 9.74313725,4.11614379 C9.74313725,4.43732026 9.77937908,4.75101307 9.84937908,5.05098039 C6.44003268,4.87973856 3.41686275,3.24630719 1.39349673,0.764248366 C1.03980392,1.36915033 0.838594771,2.07398693 0.838594771,2.82637255 C0.838594771,4.24986928 1.56346405,5.50588235 2.66326797,6.24071895 C1.99088235,6.21823529 1.35849673,6.03326797 0.804869281,5.72581699 L0.804869281,5.77705882 C0.804869281,7.76418301 2.21960784,9.42261438 4.0954902,9.80006536 C3.75179739,9.89254902 3.38937908,9.94379085 3.01444444,9.94379085 C2.7495098,9.94379085 2.49330065,9.91754902 2.2420915,9.86754902 C2.76447712,11.4984967 4.27921569,12.6845098 6.07388889,12.7170261 C4.67039216,13.8168301 2.90071895,14.4704575 0.978594771,14.4704575 C0.647418301,14.4704575 0.32120915,14.4504575 3.26797386e-05,14.4142157 C1.81594771,15.5802614 3.97179739,16.2601307 6.28885621,16.2601307 C13.8361765,16.2601307 17.9616667,10.0087908 17.9616667,4.58732026 L17.9479085,4.05617647 C18.7539869,3.48124183 19.4513399,2.75888889 20,1.93653595 Z",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterLogo);
export default __webpack_public_path__ + "static/media/twitter-logo.67ea73249404aab87768b722279bc43d.svg";
export { ForwardRef as ReactComponent };